import { type ColumnFiltersState, type PaginationState, type SortingState } from '@tanstack/react-table'
import { useState } from 'react'

interface QueryParams {
  page: number
  size: number
  sortBy?: string
  direction?: 'ASC' | 'DESC'
  [key: string]: any
}

export const usePaginatedData = <T>(
  queryFn: (params: QueryParams) => any,
  pagination: PaginationState,
  columnFilters: ColumnFiltersState,
  sorting: SortingState,
  extraParams: Record<string, any> = {},
  columnFiltersTransformer?: (filters: ColumnFiltersState) => ColumnFiltersState,
  sortingTransformer?: (sorting: SortingState) => SortingState
) => {
  const [data, setData] = useState<T | undefined>(undefined)
  const transformColumnFilters = columnFiltersTransformer || ((filters) => filters)
  const transformedColumnFilters = transformColumnFilters(columnFilters)
  const transformSorting = sortingTransformer || ((sorting) => sorting)
  const transformedSorting = transformSorting(sorting)

  const queryFilters = transformedColumnFilters.reduce((acc: Record<string, any>, filter: { id: any, value: any }) => {
    return { ...acc, [filter.id]: filter.value }
  }, {})

  const result = queryFn({
    page: pagination.pageIndex,
    size: pagination.pageSize,
    sortBy: transformedSorting[0]?.id,
    direction: transformedSorting[0]?.desc ? 'DESC' : 'ASC',
    ...queryFilters,
    ...extraParams
  })

  if (result.data !== data) {
    setData(result.data)
  }

  return {
    data: result.data ?? data,
    loading: result.isFetching ?? false
  }
}
